import { EyeStroke, FileMultipleStroke, Pencil1Stroke, PlusStroke, Trash3Stroke } from '@lineiconshq/free-icons';
import { ActionBarV2, ActionButtonV2, AritoIcon, MenuButtonV2 } from '@/components/custom/erp';

interface ActionBarProps {
  onAddIconClick: () => void;
  onEditIconClick?: () => void;
  onDeleteIconClick?: () => void;
  onCopyIconClick?: () => void;
  onWatchIconClick?: () => void;
  onRefreshIconClick?: () => void;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  onAddIconClick,
  onEditIconClick,
  onDeleteIconClick,
  onCopyIconClick,
  onWatchIconClick,
  onRefreshIconClick
}) => {
  return (
    <ActionBarV2 titleComponent={<h1 className='text-xl font-bold'>Khai báo thông tin vật tư theo đơn vị</h1>}>
      <ActionButtonV2 icon={PlusStroke} title='Thêm' onClick={onAddIconClick} variant='primary' />
      <ActionButtonV2 icon={Pencil1Stroke} title='Sửa' onClick={onEditIconClick} />
      <ActionButtonV2 icon={Trash3Stroke} title='Xóa' onClick={onDeleteIconClick} />
      <ActionButtonV2 icon={FileMultipleStroke} title='Sao chép' onClick={onCopyIconClick} />
      <ActionButtonV2 icon={EyeStroke} title='Xem' onClick={onWatchIconClick} />

      <MenuButtonV2
        items={[
          {
            title: 'Refresh',
            icon: <AritoIcon icon={15} />,
            onClick: onRefreshIconClick || (() => {}),
            group: 0
          },
          {
            title: 'Cố định cột',
            icon: <AritoIcon icon={16} />,
            onClick: () => {},
            group: 0
          },
          {
            title: 'Kết xuất dữ liệu',
            icon: <AritoIcon icon={18} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Tải mẫu Excel',
            icon: <AritoIcon icon={28} />,
            onClick: () => {},
            group: 2
          },
          {
            title: 'Lấy dữ liệu từ Excel',
            icon: <AritoIcon icon={29} />,
            onClick: () => {},
            group: 2
          }
        ]}
      />
    </ActionBarV2>
  );
};

export default ActionBar;
